import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./commiteeFunctions.css";
import { resources } from "../Resourses/Resources";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";

const CommiteeFunctions = () => {
  const [heading, setHeading] = useState("");
  const [descriptions, setDescriptions] = useState([
    {
      // uniqueKey: Date.now(),
      type: "",
      heading: "",
      content: "",
    },
  ]);
  const [committeeType, setCommitteeType] = useState("");
  const [sectionType, setSectionType] = useState("");
  const [committeeData, setAllCommitteData] = useState([]);
  const [CommiteeTypeData, setAllCommiteTypeData] = useState();

  const navigate = useNavigate();

  const handleAddPoint = () => {
    setDescriptions([
      ...descriptions,
      {
        // uniqueKey: Date.now(),
        type: sectionType,
        heading:
          heading ||
          (sectionType === "roles" ? "ROLES & RESPONSIBILITIES" : "OBJECTIVES"),
        content: "",
      },
    ]);
  };

  const getCommiteeTypeData = async (value) => {
    try {
      const res = await axios.get(
        resources.APPLICATION_URL +
          `committees/getCommitteesByCommitteeType?committeeType=${encodeURIComponent(
            value
          )}`
      );
      console.log("Get CommiteType Data=====>>>>>>", res);
      setAllCommiteTypeData(res.data.data);
    } catch (e) {
      console.log("Get CommiteType Data=====>", e);
    }
  };

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const newDescriptions = [...descriptions];
    newDescriptions[index] = {
      ...newDescriptions[index],
      [name]: value,
    };
    setDescriptions(newDescriptions);
  };

  const handleRemovePoint = (index) => {
    const newDescriptions = descriptions.filter((_, i) => i !== index);
    setDescriptions(newDescriptions);
  };

  const handlegetAllCommitteData = async () => {
    try {
      const res = await axios.get(
        resources.APPLICATION_URL + "get/all/committees"
      );
      if (res.data) {
        setAllCommitteData(res.data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    handlegetAllCommitteData();
  }, []);

  const handleUpload = async () => {
    //   const data = {
    //     heading,
    //     descriptions,
    //     committeeType,
    //     sectionType
    //   };
    //   localStorage.setItem('committeeData', JSON.stringify(data));
    //   console.log("Upload Committee Functions", data);
    try {
      const response = await axios.post(
        resources.APPLICATION_URL + `edit/commitees`,

        {
          committees: CommiteeTypeData.committees,
          cordinator: CommiteeTypeData.cordinator,
          cordinatorEmail: CommiteeTypeData.cordinatorEmail,
          cordinatorMobileNumber: CommiteeTypeData.cordinatorMobileNumber,
          committeesChild: descriptions,
        }
      );
      console.log("Get Total Commitee Functions Data", response);
      setHeading("");
      setDescriptions([
        {
          type: "",
          heading: "",
          content: "",
        },
      ]);
      setCommitteeType("");
      setSectionType("");
      setAllCommiteTypeData(null);
    } catch (e) {
      console.log("Error Total Commitee Functions Data===>", e);
    }
  };

  const handleSectionChange = (e) => {
    const value = e.target.value;
    setSectionType(value);
    // const defaultHeading =
    // value === "roles" ? "ROLES & RESPONSIBILITIES" : "OBJECTIVES";
    setDescriptions([
      {
        // uniqueKey: Date.now(),
        type: value,
        heading: "",
        content: "",
      },
    ]);
    // setHeading(defaultHeading);
  };

  return (
    <div className="Commite_function_text-committee-container">
      <h2 className="Commite_function_text-heading">Committee Functions</h2>

      <label className="Commite_function_text-label">Committee Type:</label>
      <select
        value={committeeType}
        onChange={(e) => {
          setCommitteeType(e.target.value);
          getCommiteeTypeData(e.target.value);
        }}
        className="Commite_function_text-input"
      >
        <option value="">Select Committee Type</option>
        {committeeData?.map((each, index) => (
          <option key={index} value={each.committees}>
            {each.committees}
          </option>
        ))}
      </select>

      <label className="Commite_function_text-label">Section Type:</label>
      <select
        value={sectionType}
        onChange={(e) => handleSectionChange(e)}
        className="Commite_function_text-input"
      >
        <option value="">Select Section</option>
        <option value="Functions">Functions</option>
        <option value="roles">Roles & Responsibilities</option>
      </select>

      <label className="Commite_function_text-label">Heading:</label>
      <input
        type="text"
        value={heading}
        onChange={(e) => {
          setHeading(e.target.value);
          setDescriptions((prevDescriptions) => {
            const newDescriptions = [...prevDescriptions];
            newDescriptions[0] = {
              ...newDescriptions[0],
              heading: e.target.value,
            };
            return newDescriptions;
          });
        }}
        placeholder="Enter heading"
        className="Commite_function_text-input"
      />

      <label className="Commite_function_text-label">Description Points:</label>
      {descriptions?.map((desc, index) => (
        <div
          key={desc.uniqueKey}
          style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}
        >
          <input
            type="text"
            value={desc.content}
            name="content"
            onChange={(e) => handleChange(index, e)}
            placeholder={`Point ${index + 1}`}
            className="Commite_function_text-input"
            style={{ flex: 1, marginRight: "8px" }}
          />
          <RemoveCircleIcon
            onClick={() => handleRemovePoint(index)}
            className="Commite_function_text-RemoveCircleIcon"
            style={{ color: "red", cursor: "pointer" }}
          />
        </div>
      ))}

      <button onClick={handleAddPoint} className="Commite_function_text-button">
        Add Point
      </button>
      <button onClick={handleUpload} className="Commite_function_text-button">
        Upload
      </button>
    </div>
  );
};

export default CommiteeFunctions;
